// queries.js

import { gql } from "@apollo/client";

export const GET_CLIENTS_QUERY = gql`
  query (
    $search: String
    $first: Int
    $skip: Int
    $sortField: String
    $sortOrder: String
    $packages: [Int]
    $towers: [String]
  ) {
    clients(
      search: $search
      first: $first
      skip: $skip
      sortField: $sortField
      sortOrder: $sortOrder
      packages: $packages
      towers: $towers
    ) {
      currentPage
      hasNextPage
      hasPreviousPage
      totalPages
      totalRecords
      items {
        id
        name
        surname
        saId
        clientId
        whBalance
        nextOfKinName
        nextOfKinPhone
        channel
        energyTradingEnabled
        tower {
          zonkeId
        }
        package {
          name
        }
      }
    }
  }
`;

export const GET_CLIENT_QUERY = gql`
  query ($clientId: Int!) {
    client(clientId: $clientId) {
      id
      name
      surname
      active
      saId
      clientId
      channel
      balance
      whBalance
      contactMethod
      phoneNumber
      createdDate
      nextOfKinName
      nextOfKinPhone
      w3w
      expiryDate
      tower {
        zonkeId
      }
      isHost
      package {
        name
        id
      }
    }
  }
`;

export const GET_AUTHED_CLIENT_QUERY = gql`
  query {
    authenticatedClient {
      id
      name
      surname
      saId
      clientId
      channel
      isExpired
      balance
      contactMethod
      phoneNumber
      nextOfKinName
      nextOfKinPhone
      createdDate
      bsgClaimed
      w3w
      package {
        name
        price
      }
      latestmetertelemetrySet {
        state
      }
      tower {
        zonkeId
      }
      expiryDate
      package {
        name
        id
      }
      transactionSet {
        amount
        id
        purchaseType
        platform
        success
        timestamp
        transactionId
        vendor
      }
    }
  }
`;
